import React, { useEffect, useState, useReducer, useCallback } from "react";
import {
  Link,
  useParams,
  useLocation,
  NavLink,
  useHistory,
} from "react-router-dom";
import classNames from "classnames";
import AdminNavbarLinks from "./AdminNavbarLinks";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";
import { ReactComponent as MenuIcon } from "assets/img/icons/menu.svg";
import logo from "assets/img/reteam_logo.png";
import { useGlobalContext } from "store/contexts/globalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import DropDown from "components/CustomDropDown";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { ReactComponent as ArrowDown } from "assets/img/icons/arrowdown.svg";
import { ReactComponent as ArrowUp } from "assets/img/icons/arrowup.svg";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import { navbarState, navbarReducer } from "store/reducers/navbarReducer";

export default function Header(props) {
  const {
    routes,
    team = null,
    teamNavbar = false,
    generalTab,
    setTeamId,
    handleLeftSidebarDrawer,
    handleRightSidebarDrawer,
    displayBackButton = true,
  } = props;
  const [{ heading, activeRoutePath, linkRoutes, dropDownRoutes }, dispatch] =
    useReducer(navbarReducer, navbarState);
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const { microsoftConfigureTab, ringCentral } = useGlobalContext();
  const { teams } = useSelector((state) => state.teamsReducer);
  const [displayMore, setDisplayMore] = useState(false);

  useEffect(() => {
    if (routes !== undefined) {
      const routesData = [...routes]
        .filter((route) => !route.hideFromSidebar && !route.dropDown)
        .map((route) => {
          route.link = route.path;

          Object.keys(params).forEach((key) => {
            const paramValue = params[key];

            route.link = route.link.replace(`:${key}`, paramValue);
          });

          return route;
        });

      const dropDownData = [...routes].filter((route) => route.dropDown);

      dispatch({ type: "setDropDownRoutes", value: dropDownData });
      dispatch({ type: "setHeading", value: "My Team" });

      if (location.pathname === "/dashboard") {
        dispatch({ type: "setHeading", value: "Dashboard" });
      }

      dispatch({ type: "setLinkRoutes", value: routesData });
      dispatch({ type: "setActiveRoutePath", value: location.pathname });
    }
  }, [location, params, routes]);

  useEffect(() => {
    if (!displayMore) {
      return;
    }

    setDisplayMore(false);

    //eslint-disable-next-line
  }, [activeRoutePath]);

  const activeRoute = useCallback(
    (routeName) => {
      return activeRoutePath.indexOf(routeName) > -1 ? true : false;
    },
    [activeRoutePath]
  );

  var routeNameArray = activeRoutePath.split("/");

  const Navbar = useCallback(
    (prop, key) => {
      var listItemClasses;
      listItemClasses = classNames({
        //eslint-disable-next-line
        [" " + "active"]: !teamNavbar
          ? activeRoute(prop.layout + (prop?.link ?? prop?.path))
          : false,
      });
      return (
        <div key={key}>
          {!microsoftConfigureTab && (
            <NavLink
              style={{ textDecoration: "none" }}
              key={key}
              to={prop.layout + (prop?.link ?? prop?.path)}
              activeClassName="active"
            >
              <li className="nav-item">
                <p className={"nav-link" + listItemClasses} aria-current="page">
                  {typeof prop.icon === "string" && (
                    <ConvertSvgToComponent
                      icon={prop.icon}
                      imageclass="mainIcon"
                    />
                  )}
                  {prop.name}
                </p>
              </li>
            </NavLink>
          )}
        </div>
      );
    },
    [activeRoute, teamNavbar, microsoftConfigureTab]
  );

  var links = !microsoftConfigureTab && (
    <div
      style={{ justifyContent: "center" }}
      className="collapse navbar-collapse"
      id="navbarSupportedContent"
    >
      <ul className="navbar-nav mb-2 mb-lg-0">
        {linkRoutes.map((prop, key) => {
          return Navbar(prop, key);
        })}
        <li className="nav-item">
          <p
            className={classNames({
              "nav-link": true,
              "nav-link-active": dropDownRoutes.some((route) =>
                route.path === activeRoutePath ? true : false
              ),
            })}
            onClick={() => setDisplayMore(!displayMore)}
          >
            {!displayMore && <ArrowDown className="mainIcon" />}
            {displayMore && <ArrowUp className="mainIcon" />}
            More
          </p>
          <CSSTransition
            in={displayMore}
            timeout={300}
            unmountOnExit
            classNames="dropdown-secondary"
          >
            <ClickAwayListener onClickAway={() => setDisplayMore(false)}>
              <div className="moreMenu">
                {dropDownRoutes.map((prop, key) => {
                  return Navbar(prop, key);
                })}
              </div>
            </ClickAwayListener>
          </CSSTransition>
        </li>
      </ul>
    </div>
  );

  var brand = !microsoftConfigureTab && (
    <Link to={"/"} style={{ pointerEvents: ringCentral ? "none" : "all" }}>
      <p className="navbar-brand navbar-logo">
        <img className="logo" alt="ReTeam Logo" src={logo} />
      </p>
    </Link>
  );

  var myTeams = !microsoftConfigureTab && (
    <>
      {!ringCentral && (
        <div>
          <h5 className="mbl-page-title">
            {!microsoftConfigureTab && (
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  pointerEvents: !ringCentral ? "all" : "none",
                }}
                className="navbarTeamTitle"
              >
                {team?.name ?? heading}
              </Link>
            )}
          </h5>
        </div>
      )}
      {ringCentral && (
        <div>
          <img style={{ width: "70%" }} alt="ReTeam Logo" src={logo} />
        </div>
      )}
    </>
  );

  const timelineRedirect = () => {
    if (generalTab.name === "general") {
      props.setGeneralTab({ ...generalTab, value: true });
      history.push("/teams/general/timeline");
      return;
    }

    history.push(`/teams/${team?.id}/timeline`);
  };

  var goToTimeline = microsoftConfigureTab && displayBackButton && (
    <div>
      <h5 className="mbl-page-title microsoftTimelineTitle">
        {microsoftConfigureTab && !generalTab?.value && (
          <div
            onClick={timelineRedirect}
            style={{ textDecoration: "none", cursor: "pointer" }}
            className="msbackButton"
          >
            <div style={{ color: "#2a323d" }}>
              {!["un-authorize", "timeline"].includes(
                routeNameArray[routeNameArray.length - 1]
              ) && <FontAwesomeIcon icon={faArrowCircleLeft} />}
              {team && (
                <div className="msTeamHeading">
                  <span>
                    <img
                      className="teamImage"
                      src={team?.avatar ?? DefaultTeamAvatar}
                      alt="teamName"
                    />
                  </span>
                  <span className="msDropDownHeader">{team?.name}</span>
                </div>
              )}
            </div>
          </div>
        )}
        {microsoftConfigureTab && generalTab?.value && team && (
          <DropDown
            name={team?.name}
            clidClassName="msDropDownChild"
            onClick={(team) => setTeamId(team?.id)}
            headerClassName={"msDropDownHeader"}
            dropDownData={teams?.filter((team) => team?.id !== props.teamId)}
          />
        )}
      </h5>
    </div>
  );

  return (
    <header className="main-header" id="header">
      <div className="header desktop-header">
        <nav className="navbar navbar-expand-md navbar-light">
          <div className="container-fluid dashboard-container">
            {goToTimeline}
            {brand}
            {links}
            <div className="mobile-header">
              <nav className="nav-bar" id="navigation">
                <ul className="nav-bar__list">
                  <li></li>
                </ul>
                <div className="hamburguer_menu--close">
                  <div className="hamburguer_menu__item--close item--close-1" />
                  <div className="hamburguer_menu__item--close item--close-2" />
                </div>
              </nav>
              {!microsoftConfigureTab && (
                <div className="hamburguer_menu">
                  <MenuIcon
                    className="hamburguer_menu__item"
                    onClick={handleLeftSidebarDrawer}
                  />
                </div>
              )}
              <div>{myTeams}</div>
            </div>
            <AdminNavbarLinks team={team} />
            {team && (
              <div className="rightSideHamBurger">
                <MenuIcon
                  className="hamburguer_menu__item"
                  onClick={handleRightSidebarDrawer}
                />
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}
